

















import Vue, { PropType } from "vue";
import { mapActions, mapState } from "vuex";
import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { CashTypeEnum, cashTypeEnumLabel } from "@/model/data/enums/CashTypeEnum";
import { StockTypeEnum, stockTypeEnumLabel } from "@/model/data/enums/StockTypeEnum";
import { RootState } from "@/store";
import { GET_WORKLOAD_CURRENCIES } from "@/store/modules/InstallationsWorkloadModule/actions";

export default Vue.extend({
    components: {},
    data: function() {
        return {};
    },
    props: {
        widget: Object as PropType<DashboardWidget>,
    },
    computed: {
        ...mapState({
            currencies: (state: RootState) => state.installationWorkload.currencies,
        }),
        availableCashTypes() {
            return [
                {
                    value: CashTypeEnum.Banknote,
                    text: this.$t(cashTypeEnumLabel(CashTypeEnum.Banknote)),
                },
                {
                    value: CashTypeEnum.Coin,
                    text: this.$t(cashTypeEnumLabel(CashTypeEnum.Coin)),
                },
            ];
        },
        availableStockTypes() {
            return [
                {
                    value: StockTypeEnum.Bag,
                    text: this.$t(stockTypeEnumLabel(StockTypeEnum.Bag)),
                },
                {
                    value: StockTypeEnum.Roll,
                    text: this.$t(stockTypeEnumLabel(StockTypeEnum.Roll)),
                },
                {
                    value: StockTypeEnum.NotRecycling,
                    text: this.$t(stockTypeEnumLabel(StockTypeEnum.NotRecycling)),
                },
            ];
        },
    },
    methods: {
        ...mapActions([GET_WORKLOAD_CURRENCIES]),
    },
    mounted() {
        if (!this.currencies || !this.currencies.length) this[GET_WORKLOAD_CURRENCIES]();
    },
});
